import { defineMessages } from "@formatjs/intl"
import type { AccidentOptions } from "./AccidentOptions"

export const accidentFreeMessages = defineMessages<AccidentOptions>({
	ACCIDENT_FREE: {
		defaultMessage: "accident free",
		id: "conditionAndService.accident.accidentFree",
	},
	NOT_ACCIDENT_FREE: {
		defaultMessage: "Not accident free",
		id: "conditionAndService.accident.notAccidentFree",
	},
})

export const knownAccidentsMessages = defineMessages<AccidentOptions>({
	ACCIDENT_FREE: {
		defaultMessage: "No damages or accidents reported",
		id: "conditionAndService.accident.noAccidentsReported",
	},
	NOT_ACCIDENT_FREE: {
		defaultMessage: "At least one damage or accident reported",
		id: "conditionAndService.accident.accidentsReported",
	},
})
